type Env = {
  REACT_APP_AUTH_HOST: string;
  REACT_APP_CMS_GRAPHQL_HOST: string;
  REACT_APP_CMS_HOST: string;
  REACT_APP_TENANT_ID: string;
};

declare global {
  interface Window {
    env: Env;
  }
}

const mainEnviroment =
  process.env.NODE_ENV === 'development' ? process.env : window.env;

export const ENV: Env = {
  REACT_APP_AUTH_HOST:
    mainEnviroment.REACT_APP_AUTH_HOST || 'http://localhost:3334',
  REACT_APP_CMS_GRAPHQL_HOST:
    mainEnviroment.REACT_APP_CMS_GRAPHQL_HOST ||
    'http://localhost:3333/graphql',
  REACT_APP_CMS_HOST:
    mainEnviroment.REACT_APP_CMS_HOST || 'http://localhost:3333',
  REACT_APP_TENANT_ID: mainEnviroment.REACT_APP_TENANT_ID || 'default',
};
